import { IAdminEvent } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../..';

export const get = async (
  state: IStore,
  clubId: number | string,
  eventId: number | string,
  force?: boolean
) => {
  if (state.adminEvents[Number(eventId)] && !force) {
    return state;
  }

  const response = await request.get(`${api.admin.events(Number(clubId))}${eventId}/`);

  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving the Event.' } } };
  }

  const event: IAdminEvent = response;
  return {
    adminEvents: {
      [event.id]: event,
      current: event
    }
  };
};
